import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TestReportSummarizationState } from '../states/testReport.state';

// Feature selector for the Test Report Summarization state
export const selectTestReportSummarizationState =
  createFeatureSelector<TestReportSummarizationState>('testReport');

// Select data from the state
export const selectTestReportSummarizationData = createSelector(
  selectTestReportSummarizationState,
  (state) => state.testReport
);

// Select meta data from the state
export const selectTestReportSummarizationMetaData = createSelector(
  selectTestReportSummarizationState,
  (state) => state.metadata
);

// Select loading status from the state
export const selectTestReportSummarizationLoading = createSelector(
  selectTestReportSummarizationState,
  (state) => state.loading
);

// Select error status from the state
export const selectTestReportSummarizationError = createSelector(
  selectTestReportSummarizationState,
  (state) => state.error
);
